// api
import axios from 'axios';

const subscribeUserToNewsletter = (email: string, source: string): Promise<any> => {
  return axios.post('https://www.parentbirth.com/api/patients/newsletter', { email, source });
};

export default { subscribeUserToNewsletter };
